// Parse Indian price strings ("₹1.85 Cr", "₹95 L", "₹85 Lakh", "1.2 Cr") → number (₹).
// Returns NaN if it can't parse.
export const parseIndianPrice = (raw) => {
  if (!raw) return NaN;
  const s = String(raw).replace(/[₹,\s]/g, '').toLowerCase();
  const m = s.match(/([\d.]+)\s*(cr|crore|crores|l|lakh|lakhs|k)?/i);
  if (!m) return NaN;
  const n = parseFloat(m[1]);
  if (Number.isNaN(n)) return NaN;
  const unit = (m[2] || '').toLowerCase();
  if (unit.startsWith('cr')) return n * 1e7;
  if (unit.startsWith('l')) return n * 1e5;
  if (unit === 'k') return n * 1e3;
  return n;
};

// Parse "1850 sq ft", "1100 sqft", "2400 SQ. FT." → 1850
export const parseSqFt = (raw) => {
  if (!raw) return NaN;
  const m = String(raw).replace(/,/g, '').match(/(\d+(?:\.\d+)?)/);
  return m ? parseFloat(m[1]) : NaN;
};

// Best-effort numeric price for comparison: prefer startingPrice (lower bound),
// fall back to single price.
export const numericPrice = (listing) => {
  const candidates = [
    listing.starting_price,
    listing.price,
    listing.ending_price,
  ].filter(Boolean);
  for (const c of candidates) {
    const n = parseIndianPrice(c);
    if (!Number.isNaN(n)) return n;
  }
  return NaN;
};

// Format a per-sqft rupee value: "₹13.4k/sq ft" or "₹14,300/sq ft".
export const formatPerSqFt = (rupees) => {
  if (!Number.isFinite(rupees) || rupees <= 0) return '—';
  if (rupees >= 1000) {
    return `₹${(rupees / 1000).toFixed(1)}k/sq ft`;
  }
  return `₹${Math.round(rupees).toLocaleString('en-IN')}/sq ft`;
};

// Compute ₹/sq ft for a listing. Returns NaN if missing inputs.
export const pricePerSqFt = (listing) => {
  const price = numericPrice(listing);
  const sqft = parseSqFt(listing.area || listing.size);
  if (!Number.isFinite(price) || !Number.isFinite(sqft) || sqft <= 0) return NaN;
  return price / sqft;
};
